// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1WeKk","buttons":"Footer_buttons__3naDM"};